$(function () {
  if (!customElements.get('link-landing-banner')) {
    customElements.define(
      'link-landing-banner',
      class globalBanner extends HTMLElement {
        constructor() {
          super();
        }

        static get observedAttributes() {
          return ['data-theme', 'data-defaultscreen'];
        }

        connectedCallback() {
          console.log('link-landing-banner');
          this.init();
          this.scroll();
        }

        init() {
          // 初始化必要的变量和元素
          this.$header = document.getElementById('header-01');
          this.$ltHeader = document.getElementById('lt-header');
          this.$headerContainer = $('.header-container');
          this.$headerLayout = document.querySelector('nav-layout');
          this.$bubbleContainerList = document.querySelectorAll('.bubble-container');
          this.announcement = $('.announcement-bar');

          // 滚动相关变量
          this.$lastScrollTop = 0;
          this.$scrollThreshold = 50;
          this.$scrollShow = true;
          this.$defaultScreen = this.getAttribute('data-defaultscreen') === 'true';
          this.$theme = this.$ltHeader ? this.$ltHeader.getAttribute('data-theme') : 'light';
        }

        attributeChangedCallback(name, oldValue, newValue) {
          if (oldValue === newValue) return;

          // 处理 data-defaultscreen 属性
          if (name === 'data-defaultscreen') {
            if (newValue === 'true') {
              // 设置 lt-header 的 data-screen 为 true
              const headerElement = document.getElementById('lt-header');
              if (headerElement) {
                headerElement.setAttribute('data-screen', 'true');
              }

              // 获取 nav-layout 元素并移除 text-white 类
              const header = document.getElementById('header-01');

              if (header) {
                console.log('header', header);
                console.log('移除前的类名:', header.className);
                header.classList.remove('bg-white', 'header-light', 'light-default', 'screen-nav');
                header.classList.add('bg-transparent', 'absolute');
                console.log('添加后的类名:', header.className);
              }
            }
          }
          if (name === 'data-theme') {
            if (newValue === 'dark') {
              const headerElement = document.getElementById('lt-header');
              if (headerElement) {
                headerElement.setAttribute('data-theme', 'dark');
              }
            } else {
              const headerElement = document.getElementById('lt-header');
              if (headerElement) {
                headerElement.setAttribute('data-theme', 'light');
              }
            }
          }
        }

        // 应用滚动样式的方法
        applyScrollStyles() {
          if (!this.$header || !this.$ltHeader) return;

          const scrollTop = $(window).scrollTop();

          if (this.announcement && this.announcement.length > 0) {
            if (scrollTop > this.announcement.height()) {
              this.$header.classList.remove('bg-transparent', 'border-transparent');
              this.$header.classList.add('bg-white', 'header-light');
              if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                this.$ltHeader.setAttribute('data-screen', false);
              }
              if (this.$headerLayout) {
                this.$headerLayout.classList.remove('text-white');
              }
            } else {
              this.$header.classList.remove('bg-white', 'header-light', 'light-default');
              this.$header.classList.add('bg-transparent');
              if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
                this.$ltHeader.setAttribute('data-screen', true);
              }
              this.$theme = this.$ltHeader.getAttribute('data-theme');
              if (this.$theme == 'dark' && this.$defaultScreen == true) {
                if (this.$headerLayout) {
                  this.$headerLayout.classList.add('text-white');
                }
              }
            }
          } else if (scrollTop > this.$scrollThreshold) {
            this.$header.classList.remove('bg-transparent', 'border-transparent');
            this.$header.classList.add('bg-white', 'header-light');
            if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
              this.$ltHeader.setAttribute('data-screen', false);
            }
            if (this.$headerLayout) {
              this.$headerLayout.classList.remove('text-white');
            }
          } else {
            this.$header.classList.remove('bg-white', 'header-light');
            this.$header.classList.add('bg-transparent', 'border-transparent');
            if (this.$defaultScreen == true || this.$defaultScreen == 'true') {
              this.$ltHeader.setAttribute('data-screen', true);
            }
          }
        }
      }
    );
  }
});
